const Style = {
    stack: 'space-y-6',
    cardHint: 'mb-4 text-sm text-text-secondary',
    csvBlock: 'border-t border-border pt-6',
    fileLabel: `inline-flex cursor-pointer items-center rounded-md border border-border bg-secondary
        px-3 py-2 text-sm font-medium text-text-primary transition-colors hover:bg-muted/70`,
    dangerCard: 'w-full border-error/30',
};

export default Style;
